import http from '../utils/request'

/**
 * 个人设置接口 — 对应后端 UserSettingController (/api/usersetting)
 */

// 外出设置
export const getOutSetting = () => http.get('/usersetting/outsetting')
export const saveOutSetting = (data) => http.post('/usersetting/outsetting', data)

// 代理规则 ruleType: 1=直接代理, 2=外出代理
export const getAgentRules = (ruleType) => http.get(`/usersetting/rules/${ruleType}`)
export const saveAgentRule = (data) => http.post('/usersetting/rules', data)
export const deleteAgentRule = (ruleGuid) => http.delete(`/usersetting/rules/${ruleGuid}`)

// 获取可选流程列表
export const getAvailableProcesses = (ruleType, excludeRuleGuid) => {
  const params = { excludeRuleGuid: excludeRuleGuid || '' }
  return http.get(`/usersetting/available-processes/${ruleType}`, { params })
}
